<script>
	import axios from 'axios';
	import { randomizer } from "../utilities";
	import CONFIG from "../../store/config/development.js";

	var images = require.context('../../img/candidatos/', false, /\.jpg$/);

	var sortByOffice = function(list){
		if (list.length > 0 ) {
			const officeNames = [
				"Presidenta",
				"Presidente",
				"Deputada Federal",
				"Deputado Federal",
				"Deputado(a) Federal",
				"Senadora",
				"Senador",
				"Senador(a)",
				"Governadora",
				"Governador",
				"Governador(a)",
				"Deputada Distrital",
				"Deputado Distrital",
				"Deputado(a) Distrital",
				"Deputada Estadual",
				"Deputado Estadual",
				"Deputado(a) Estadual",
				"Prefeito",
				"Prefeita",
				"Prefeito(a)",
				"Vice-prefeita",
				"Vice-prefeito",
				"Vice-prefeito(a)",
				"Vereadora",
				"Vereador",
				"Vereador(a)",
			];

			return (list || []).sort(function(a, b){
				let officeA = officeNames.indexOf(a.office);
				let officeB = officeNames.indexOf(b.office);

				if (officeA !== officeB) {
					return officeA < officeB ? -1 : 1;
				} else {
					return 0;
				}
			});
		}
	};

	export default {
		name: 'candidatesSection',
		data(){
			return {
				electionList: [],

				loading: true,
			}
		},
		computed: {
			sortedElectionList() {
				return this.electionList.sort((a, b) => a.year < b.year ? 1 : -1);
			}
		},
		methods: {
			imgUrl: function (path) {
				return images('./' + path);
			},

			$_getCandidates: ((endpoint = '/api/candidate-metadata') => {
				this.loading = true;

				return new Promise((resolve, reject)=>{
					axios.get(endpoint).then((response)=>{
						const candidates = response.data.candidates || [];

						this.loading = false;

						resolve(candidates);
					}).catch((error)=>{
						reject(error);
					})
				});
			}),
		},
		mounted(){
			this.$_getCandidates().then((result) => {
				this.electionList.push({
					intro: 'Conheca alguns dos lideres que já estão usando o Voto Legal em 2020',
					candidates: result,
					year: 2020,
				});
			});
			this.$_getCandidates('/static/candidate-metadata.json').then((result) => {
				this.electionList.push({
					intro: 'Alguns dos lideres que usaram o Voto Legal em 2018',
					candidates: sortByOffice(randomizer(result)),
					year: 2018,
				});
			});
		},
	}
</script>

<template>
	<div id="candidates" class="row background-green" :aria-busy="loading" v-if="sortedElectionList.length">
		<div class="container">
			<section
				v-for="(election, idx) in sortedElectionList"
				:key="idx"
				class="section"
			>
				<h2
					class="title"
				>
					{{ election.intro }}
				</h2>
				<div class="candidatos-wrap">
					<template
						v-for="candidate in election.candidates"
					>
						<a
							class="candidato"
							target="_blank"
							:href="candidate.url+'?ref=votolegal'"
							:key="candidate.name"
							v-if="candidate.avatar || candidate.picture"
						>
							<div class="img-content">
								<img :src="candidate.avatar || candidate.picture" :alt="candidate.popular_name">
							</div>
							<h3>{{ candidate.popular_name }}</h3>
							<h4 v-show="candidate.address_state_name">
								{{ candidate.address_state_name}}
							</h4>
							<h4 v-show="candidate.office">
								{{ candidate.office }}
							</h4>
						</a>
					</template>
				</div>
			</section>
		</div>
	</div>
</template>

<style lang="scss">
	#candidates {
		background-color: #2e656f;

		.section {
			text-align: left;

			+ section {
				padding-top: 0;
			}

			h2 {
				text-transform: uppercase;
				padding-bottom: 0;

			}

			.candidatos-wrap {
				position: relative;
				padding-top: 25px;
				overflow: hidden;
				width: 100%;
				margin: 0 auto;
				text-align: center;

				&::after {
					content: '';
					display: table;
					clear: both;
				}

				.img-content {
					background-color: white;
					margin-left: auto;
					margin-right: auto;
				}

				img {
					max-width: 100%;
					min-width: 100%;
					min-height: 100%;
					object-fit: cover;
				}

				.candidato {
					color: #fff;
					display: inline-block;
					min-width: 230px;
					text-align: center;
					font-weight: bold;
					text-transform: uppercase;
					margin-bottom: 40px;

					@media screen and (min-width: 410px) {
						padding-right: 22px;
						padding-left: 22px;
					}

					.img-content {
						width: 180px;
						height: 180px;

						object-fit: contain;
						border-radius: 50%;
						overflow: hidden;
						margin-top: 25px;

						@media screen and (min-width: 640px) {
							width: 180px;
							height: 180px;
						}
					}

					h3,
					h4 {
						color: inherit;
						text-align: inherit;
					}

					h3 {
						margin-top: 10px;
					}

					h4 {
						font-size: smaller;
					}

					p {
						font-weight: bold;
						margin-top: 10px;
					}
				}
			}

		}
	}
</style>



// WEBPACK FOOTER //
// _source/javascript/components/candidatesSection.vue